import "../DrugOrderConfirmLotTable/DrugOrderConfirmLotTable.css";

const ReconcilliationConfirmTable = ({ data }) => {
  return (
    <div className="drug-order-confirm-lot-table-container">
      <table className="drug-order-confirm-lot-table">
        <thead className="drug-order-confirm-lot-table-header">
          <tr>
            <th className="drug-order-confirm-table-header-name">Drug Kit</th>
            <th className="drug-order-confirm-table-header-name">
              Reconciliation Type
            </th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {data &&
            data.map((item, index) => (
              <tr key={index}>
                <td className="drug-order-confirm-table-data">{item?.key}</td>
                <td className="drug-order-confirm-table-data">{item?.value}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReconcilliationConfirmTable;
